import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL BANNERS -------------------- */
export const AllBannersThunk = createAsyncThunk(
  "banners/AllBannersThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin-banners/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch banners");
    }
  }
);

/* -------------------- GET SINGLE BANNER -------------------- */
export const GetSingleBannersThunk = createAsyncThunk(
  "banners/GetSingleBannersThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin-banners/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch banner details"
      );
    }
  }
);

/* -------------------- ADD BANNER -------------------- */
export const AddBannersThunk = createAsyncThunk(
  "banners/AddBannersThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin-banners/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add banner");
    }
  }
);

/* -------------------- UPDATE BANNER -------------------- */
export const UpdateBannersThunk = createAsyncThunk(
  "banners/UpdateBannersThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin-banners/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update banner");
    }
  }
);

/* -------------------- DELETE BANNER -------------------- */
export const DeleteBannersThunk = createAsyncThunk(
  "banners/DeleteBannersThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin-banners/delete?uuid=${uuid}`
      );
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete banner");
    }
  }
);
